import { useEffect, useState } from "react";
import { api } from "../lib/api";
import MultiSelect from "./MultiSelect";

export const LABELS = { area: "Area / 区域", kategori: "Kategori / 类别", spesifikasi: "Spesifikasi / 规格", dimensi: "Dimensi / 尺寸", tebal: "Tebal / 厚度", grade: "Grade / 钢级", po: "No PO / 采购单", supplier: "Supplier / 供货商", proyek: "Proyek / 项目", vendor: "Vendor / 领料方", aktivitas: "Jenis / 类型", status: "Status / 状态" };

export const toParams = (sel) => Object.fromEntries(Object.entries(sel).map(([k, v]) => [k, Array.isArray(v) ? v.join(",") : v]));

let cache = null;
export function useFilterOptions() {
  const [opt, setOpt] = useState(cache);
  useEffect(() => { if (!cache) api.get("/stock/filters").then((r) => { cache = r.data; setOpt(r.data); }).catch(() => {}); }, []);
  return opt;
}

export default function FilterBar({ keys, sel, onChange, testid = "filter" }) {
  const opt = useFilterOptions();
  return (
    <div className="filter-bar" data-testid={testid}>
      {keys.map((k) => <MultiSelect key={k} label={LABELS[k] || k} options={opt?.[k] || []} value={sel[k] || []} onChange={(v) => onChange({ ...sel, [k]: v })} testid={`${testid}-${k}`} />)}
      {Object.values(sel).some((v) => Array.isArray(v) && v.length > 0) && <button type="button" className="btn-mini" onClick={() => onChange(Object.fromEntries(keys.map((k) => [k, []])))} data-testid={`${testid}-clear`}>Hapus filter / 清除</button>}
    </div>
  );
}
